import React from 'react'
import Categories from '../component/Home/Categories'
import ProductList from '../component/Home/ProductList'


const Home = () => {
    return (
        <div>
            <Categories />
            <ProductList/>
        </div>
    )
}

export default Home
